// react
import React, { useState, useEffect } from "react";

// third-party
import classNames from "classnames";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link, useHistory } from "react-router-dom";

// application
import AsyncAction from "./AsyncAction";
import Currency from "./Currency";
import { cartAddItem, cartRemoveItem } from "../../store/cart";
import { compareAddItem } from "../../store/compare";
import { quickviewOpen } from "../../store/quickview";
import { allEqual, getNoImg, url, returnResponsiveImg, checkProductInCart, checkHvStock } from "../../services/utils";
import { wishlistAddItem } from "../../store/wishlist";
import { useSelector, useDispatch } from "react-redux";
import InputCartQty from "./InputCartQty";

function ProductCard(props) {
    const { product, layout, quickviewOpen, design, noPrice, page, showAddCart } = props;
    const containerClasses = classNames("product-card " + design + (checkProductAvailable() ? "" : "product-card--not-available"), {
        "product-card--layout--grid product-card--size--sm": layout === "grid-sm",
        "product-card--layout--grid product-card--size--nl": layout === "grid-nl",
        "product-card--layout--grid product-card--size--lg": layout === "grid-lg",
        "product-card--layout--list": layout === "list",
        "product-card--layout--horizontal": layout === "horizontal",
    });
    const cart = useSelector((state) => state?.cart);
    const dispatch = useDispatch();
    const history = useHistory();
    let qty = checkProductInCart(cart.items, product, "qty");
    const [quantity, setQuantity] = useState(0);

    // useEffect(() => {
    //     setQuantity(qty);
    // }, [qty]);

    function returnPath() {
        if (
            window.location.pathname == "/search-products" ||
            window.location.pathname.indexOf("/category/") > -1 ||
            window.location.pathname.indexOf("/brand/") > -1
        )
            return { pathname: "/product/" + product.slug, state: { location: window.location.pathname, page: page } };
        else return url.product(product);
    }

    function checkProductAvailable() {
        let available = true;
        if (product.progression === "history") available = false;
        if (!checkHvStock(product)) available = false;
        if (product.additional?.enquiry_only == 1) available = false;

        return available;
    }

    function hasMultipleVariant() {
        return product.variant_choices[0] && product.variant_choices.length > 1 ? true : false;
    }

    const handleAddCart = async () => {
        if (hasMultipleVariant()) {
            quickviewOpen(product);
        } else {
            setQuantity(1);
            await dispatch(cartAddItem(product, product.variant_choices[0].uuid, [], 1, null, history));
        }
    };

    let badges = [];
    let image;
    let price;

    if (product.progression === "upcoming") {
        badges.push(
            <div key="new" className="product-card__badge product-card__badge--upcoming">
                Coming Soon
            </div>
        );
    } else if (product.progression === "history") {
        // badges.push(
        //     <div key="new" className="product-card__badge product-card__badge--history">
        //         Not Available
        //     </div>
        // );
    } else if (product.is_new) {
        badges.push(
            <div key="new" className="product-card__badge product-card__badge--new">
                New
            </div>
        );
    } else if (product.is_featured) {
        badges.push(
            <div className="recommend-label-block">
                <img className="recommend-label" src={`/images/icons/recommend.png`} />
            </div>
        );
    }

    badges = badges.length ? <div className="product-card__badges-list">{badges}</div> : null;

    image = (
        <div className="product-card__image product-image">
            <Link to={returnPath()} className="product-image__body">
                <img
                    className="product-image__img"
                    src={product.images && product.images[0] ? returnResponsiveImg(product.images[0]) : getNoImg()}
                    alt=""
                    onError={(e) => (e.target.src = getNoImg())}
                />
            </Link>
        </div>
    );

    price = (
        <div className="product-card__prices">
            {!product.is_sales && allEqual(product.price, "price") ? (
                <Currency value={product.price} />
            ) : product.is_sales && allEqual(product.sales_price, "price") ? (
                <>
                    <div className="product__new-price">
                        <Currency value={product.sales_price} />
                    </div>
                    {!allEqual([...product.sales_price, ...product.price], "price") ? (
                        <div className="product__old-price">
                            <Currency value={product.price} />
                        </div>
                    ) : null}
                </>
            ) : product.is_sales ? (
                <>
                    <Currency value={product.sales_price[0]} /> {product.sales_price[product.sales_price.length - 1] ? " - " : null}{" "}
                    {product.sales_price[product.sales_price.length - 1] ? (
                        <Currency value={product.sales_price[product.sales_price.length - 1]} />
                    ) : null}
                </>
            ) : (
                <>
                    <Currency value={product.price[0]} /> {product.price[product.price.length - 1] ? " - " : null}{" "}
                    {product.price[product.price.length - 1] ? <Currency value={product.price[product.price.length - 1]} /> : null}
                </>
            )}
        </div>
    );

    return (
        <div id={"product-card-" + product.slug} className={containerClasses}>
            <div className="product-card__body">
                {badges}
                {image}
                <div className="product-card__info">
                    <div className={"product-card__name " + (design == "white-background" ? "text-black" : "")}>
                        <Link to={url.product(product)}>{product.name}</Link>
                    </div>

                    <div className="product-card__features-list">{product.short_description}</div>
                </div>

                <div className="product-card__actions">
                    {/* <div className="product-card__availability">
                    Availability:
                    <span className="text-success">In Stock</span>
                </div> */}
                {noPrice || product.additional?.enquiry_only == 1 ? <div className="product-card__prices" /> : price}

                    {/* {showAddCart ? (
                        <div className="d-flex justify-content-center mt-2">
                            <button
                                type="button"
                                onClick={() => quickviewOpen(product)}
                                className="btn btn-sm btn-primary add-cart-white-btn"
                            >
                                Add To Cart
                            </button>
                        </div>
                    ) : null} */}
                </div>
            </div>
            {product.progression !== null && product.progression !== "ongoing" ? (
                <div className="add-cart-btn unavailable">
                    <div className="btn">Not Available</div>
                </div>
            ) : !checkHvStock(product) ? (
                <div className="add-cart-btn unavailable">
                    <div className="btn">Sold Out</div>
                </div>
            ) : qty ? (
                <div className="add-cart-qty-btn">
                    <InputCartQty product={product} />
                </div>
            ) : (
                <div className="add-cart-btn">
                    {product.variant_choices[0] && product.variant_choices.length > 1 ? (
                        <button type="button" onClick={() => handleAddCart()} className="btn btn-primary ">
                            Add To Cart
                        </button>
                    ) : (
                        <AsyncAction
                            action={() => dispatch(cartAddItem(product, product.variant_choices[0].uuid, [], 1, null, history))}
                            render={({ run, loading }) => (
                                <button
                                    type="button"
                                    onClick={run}
                                    className={classNames("btn btn-primary", {
                                        "btn-loading": loading,
                                    })}
                                >
                                    Add To Cart
                                </button>
                            )}
                        />
                    )}
                </div>
            )}
        </div>
    );
}

ProductCard.propTypes = {
    /**
     * product object
     */
    product: PropTypes.object.isRequired,
    /**
     * product card layout
     * one of ['grid-sm', 'grid-nl', 'grid-lg', 'list', 'horizontal']
     */
    layout: PropTypes.oneOf(["grid-sm", "grid-nl", "grid-lg", "list", "horizontal"]),
};

ProductCard.defaultProps = {
    showAddCart: false,
    design: "",
};

const mapStateToProps = () => ({});

const mapDispatchToProps = {
    wishlistAddItem,
    compareAddItem,
    quickviewOpen,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductCard);
